import { render, staticRenderFns } from "./RegisterNew.vue?vue&type=template&id=5bbfed72&scoped=true"
import script from "./RegisterNew.vue?vue&type=script&lang=js"
export * from "./RegisterNew.vue?vue&type=script&lang=js"
import style0 from "./RegisterNew.vue?vue&type=style&index=0&id=5bbfed72&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bbfed72",
  null
  
)

export default component.exports